export const TRIGGERS_PART02 = [
  {
    id: 'demo-trg-meeting-brief',
    title: 'External meeting brief',
    enabled: true,
    description: 'Sends a one-page brief an hour before you meet someone new.',
    when: {
      app: 'Google Calendar',
      event: 'Event starting in 60 minutes',
      filter: 'Has an attendee from a company you haven’t met before',
    },
    steps: [
      'Research the company: what they do, size, funding, and recent news',
      'Look up each attendee’s role and any history in HubSpot',
      'Email you a one-page brief with three suggested questions',
    ],
    apps: ['Google Calendar', 'Web research', 'HubSpot', 'Gmail'],
  },
  {
    id: 'demo-trg-spec-edit',
    title: 'Spec change summary',
    enabled: false,
    description: 'Keeps the team in sync when a product spec changes.',
    when: { app: 'Notion', event: 'Page updated', filter: 'Page is in the Product Specs database' },
    steps: [
      'Compare the page with its previous version',
      'Summarise what changed and who changed it',
      'Post the summary to #product with a link to the page',
    ],
    apps: ['Notion', 'Slack'],
  },
]
